// Page numbers for a long list: "1–15 of 120", Previous, 1 … 4 5 6 … 8, Next.
export const PAGE_SIZE = 15;

function pageNumbers(current, last) {
  const pages = new Set([1, last, current - 1, current, current + 1]);
  const list = [...pages].filter((p) => p >= 1 && p <= last).sort((a, b) => a - b);
  const out = [];
  list.forEach((p, i) => {
    if (i > 0 && p - list[i - 1] > 1) out.push(`gap-${p}`);
    out.push(p);
  });
  return out;
}

export default function Pager({ page, total, onPage, pageSize = PAGE_SIZE }) {
  const last = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(total, page * pageSize);
  return (
    <nav className="pager" aria-label="Pages">
      <span className="pager-count"><strong>{from}–{to}</strong> of {total}</span>
      <div className="pager-buttons">
        <button type="button" onClick={() => onPage(page - 1)} disabled={page <= 1}>← Previous</button>
        {pageNumbers(page, last).map((p) => (typeof p === 'string'
          ? <span key={p} className="pager-gap">…</span>
          : <button type="button" key={p} className={p === page ? 'active' : ''} aria-current={p === page ? 'page' : undefined} onClick={() => onPage(p)}>{p}</button>))}
        <button type="button" onClick={() => onPage(page + 1)} disabled={page >= last}>Next →</button>
      </div>
    </nav>
  );
}
